import React, {Component} from 'react';

import {SkyLightStateless} from 'react-skylight';

import urls from "../../../../../utils/urls";

export default class TripTruckScaleTicket extends Component {

    constructor(props){
        super(props);

        this.state = {
            showModal: false,
            trip: props.trip
        };
    }

    _closeModal = () => {
        this.setState({showModal: false});
    };

    render() {
        let {trip, showModal} = this.state;
        if(!trip || !trip.truck_scale_ticket || trip.truck_scale_ticket === '')return <span />;

        let ticketURL = `${urls.API_ROOT}${trip.truck_scale_ticket}`;

        let modalStyle = {
            boxShadow: 'none',
            top: '30%'
        };

        let height = window.innerHeight - 300;
        console.log(height);

        return (
            <div className={"ticket-container"}>
                <button className={"ticket-button"} onClick={() => this.setState({showModal: true})}>
                    Ver Ticket
                </button>

                <div style={{position: 'absolute'}}>
                    <SkyLightStateless
                        onOverlayClicked={this._closeModal}
                        isVisible={showModal}
                        onCloseClicked={this._closeModal}
                        dialogStyles={modalStyle}
                        transitionDuration={0}
                        title={<h3 className="center" style={{fontSize: '30px'}}>Ticket de Balanza</h3>}
                    >
                        <div style={{padding: '0 50px'}}>
                            {showModal &&
                            <iframe src={ticketURL} style={{width: '100%', height: height}} title={"Ticket de Balanza"} />
                            }
                            <div className={"row"}>
                                <div className={"col s12 text-center"}>
                                    <a href={ticketURL} target={"_blank"} className={"btn btn-shell z-depth-0"}>Descargar</a>
                                </div>
                            </div>
                        </div>
                    </SkyLightStateless>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Done/TripTruckScaleTicket.js